/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { FetchHttpRequest } from './core/FetchHttpRequest';
import { AdminService } from './services/AdminService';
import { AdminImportService } from './services/AdminImportService';
import { BankAccountService } from './services/BankAccountService';
import { CronService } from './services/CronService';
import { LadderService } from './services/LadderService';
import { MatchesService } from './services/MatchesService';
import { SettingsControllerService } from './services/SettingsControllerService';
import { StoreKitControllerService } from './services/StoreKitControllerService';
import { TeamsService } from './services/TeamsService';
import { TimeControllerService } from './services/TimeControllerService';
import { TipsService } from './services/TipsService';
import { TournamentsService } from './services/TournamentsService';
import { UserService } from './services/UserService';
type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;
export class backendApi {
    public readonly admin: AdminService;
    public readonly adminImport: AdminImportService;
    public readonly bankAccount: BankAccountService;
    public readonly cron: CronService;
    public readonly ladder: LadderService;
    public readonly matches: MatchesService;
    public readonly settingsController: SettingsControllerService;
    public readonly storeKitController: StoreKitControllerService;
    public readonly teams: TeamsService;
    public readonly timeController: TimeControllerService;
    public readonly tips: TipsService;
    public readonly tournaments: TournamentsService;
    public readonly user: UserService;
    public readonly request: BaseHttpRequest;
    constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = FetchHttpRequest) {
        this.request = new HttpRequest({
            BASE: config?.BASE ?? 'http://localhost:3000',
            VERSION: config?.VERSION ?? '1.0.7',
            WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
            CREDENTIALS: config?.CREDENTIALS ?? 'include',
            TOKEN: config?.TOKEN,
            USERNAME: config?.USERNAME,
            PASSWORD: config?.PASSWORD,
            HEADERS: config?.HEADERS,
            ENCODE_PATH: config?.ENCODE_PATH,
        });
        this.admin = new AdminService(this.request);
        this.adminImport = new AdminImportService(this.request);
        this.bankAccount = new BankAccountService(this.request);
        this.cron = new CronService(this.request);
        this.ladder = new LadderService(this.request);
        this.matches = new MatchesService(this.request);
        this.settingsController = new SettingsControllerService(this.request);
        this.storeKitController = new StoreKitControllerService(this.request);
        this.teams = new TeamsService(this.request);
        this.timeController = new TimeControllerService(this.request);
        this.tips = new TipsService(this.request);
        this.tournaments = new TournamentsService(this.request);
        this.user = new UserService(this.request);
    }
}

